export { default as StaticCmsIcon } from './static-cms-icon.svg';
export { default as StaticCmsLogo } from './static-cms-logo.svg';
